import React from "react";
import { EaseDrawer } from "../../libs/EaseDrawer";
import { Text1, Text3, Text5 } from "../../styles";
import { Descriptions, Button } from "antd";
import { PermissionHoc } from '../HOC';

const PermissibleButton = PermissionHoc(Button, "", { is_component: true, fallbackComponent: null })

const VirtualAccountProfileDrawer = (props) => {
    const virtualAccountInstance = props.virtualAccountInstance || {}
    const virtualAccountProfile = virtualAccountInstance.profile || {}
    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>Virtual Account KYC Profile</Text1>
                <Text5 copyable>{virtualAccountProfile.id}</Text5>
            </div>
        )
    };

    const renderBasicDetails = () => {
        return (
            <div>
                <Text3 className="d-block" style={{ marginBottom: '8px', color: 'black' }} strong>Basic Details</Text3>
                <Descriptions className="mb-4" title="" column={1} size="small" bordered>
                    <Descriptions.Item label="Email">{virtualAccountProfile.email || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Phone">{virtualAccountProfile.phone || "---"}</Descriptions.Item>
                </Descriptions>
            </div>
        )
    };

    const renderBusinessDetails = () => {
        return (
            <div>
                <Text3 className="d-block" style={{ marginBottom: '8px', color: 'black' }} strong>Business Details</Text3>
                <Descriptions className="mb-4" title="" column={1} size="small" bordered>
                    <Descriptions.Item label="Business Name">{virtualAccountProfile.business_name || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Business Type">{virtualAccountProfile.business_type_code || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Entity Type">{virtualAccountProfile.entity_type || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Business Category">{virtualAccountProfile.category_code || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Pancard">{virtualAccountProfile.pan_number || "---"}</Descriptions.Item>
                    <Descriptions.Item label="GSTIN">{virtualAccountProfile.gstin || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Business Address">{virtualAccountProfile.business_address || "---"}</Descriptions.Item>
                    <Descriptions.Item label="City">{virtualAccountProfile.city || "---"}</Descriptions.Item>
                    <Descriptions.Item label="State">{virtualAccountProfile.state || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Pincode">{virtualAccountProfile.pincode || "---"}</Descriptions.Item>
                </Descriptions>
            </div>
        )
    };

    const renderBankDetails = () => {
        return (
            <div>
                <Text3 className="d-block" style={{ marginBottom: '8px', color: 'black' }} strong>Bank Details</Text3>
                <Descriptions className="mb-4" title="" column={1} size="small" bordered>
                    <Descriptions.Item label="Account Name">{virtualAccountProfile.name_on_bank || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Account Number">{virtualAccountProfile.account_number || "---"}</Descriptions.Item>
                    <Descriptions.Item label="Account IFSC">{virtualAccountProfile.account_ifsc || "---"}</Descriptions.Item>
                    {/* <Descriptions.Item label="Bank Name">{virtualAccountProfile.bank_name || "---"}</Descriptions.Item> */}
                    {/* <Descriptions.Item label="Bank Branch">{virtualAccountProfile.bank_branch || "---"}</Descriptions.Item> */}
                </Descriptions>
            </div>
        )
    };

    const renderKyclink = () => {
        return (
            <div>
                <Text3 className="d-block" style={{ marginBottom: '8px', color: 'black' }} strong>KYC link</Text3>
                <Descriptions className="mb-4" title="" column={1} size="small" bordered>
                    <Descriptions.Item label="KYC link">{virtualAccountInstance.kyc_signed_url ? <PermissibleButton required_permission="IC_CVA_KYC_WRITE" className='ml-2' type="link" href={virtualAccountInstance.kyc_signed_url} target="_blank"> Go to KYC </PermissibleButton> : "---"}</Descriptions.Item>
                </Descriptions>
            </div>
        )
    };

    return (
            <EaseDrawer
                className="merchant-details-wrapper"
                title={false}
                width={450}
                visible={props.visible}
                onClose={props.toggleProfileDrawer}
                centered
                hideHeader
                hideFooter
                destroyOnClose
            >
                {

                    <div className="mt-3">
                        {renderTitle()}
                        {renderBasicDetails()}
                        {renderBusinessDetails()}
                        {renderBankDetails()}
                        {renderKyclink()}
                    </div>
                }
            </EaseDrawer>
    )
};

export { VirtualAccountProfileDrawer };